import React, {  } from 'react';

import { Route, Routes } from 'react-router-dom';
import { authOTPVerified, authToken } from '../storage/authToken';

import { ToastContainer } from 'react-toastify';
import { getDefaultPharmacist } from '../utils/helper/helper';
import { useAuthSelector } from '../services/selectors/authSelector';
import { useAllSelector } from '../services/selectors/allSelector';

import { ChatBox } from '../components/chat/chatBox';
import { useCustomLocation } from '../hooks';

import * as Auth from '../auth';
import * as Pages from '../pages';
import * as routeNames from './routeName';

import ProtectedRoute from './protectedRoute';
import ChatInterface from '../components/chat/initatedChatBox';
import ActivityTracker from '../components/chat/userActivityStatus';

const AppRoutes = () => {

	const token = authToken();
	const verifiedOtp = Number(authOTPVerified())
	const location = useCustomLocation()

	const { pharmacyId, isSupervisor, driverDefaultPharmacist } = useAuthSelector()
	const defaultPharmacist = getDefaultPharmacist(pharmacyId, driverDefaultPharmacist);
	const pharmacistUser = defaultPharmacist?.[0]?.driver_pharmacist_user;
	const isDriverForAuthorizationLetter = pharmacistUser?.type !== 'pharmacist';

	const { supervisor_pharmacist, supervisorOfTheDay, analyticSupervisorOftheDay,
		pharmacy_assign_chats,
	} = useAllSelector()

	return (

		<>
			<Routes>
				<Route exact path={routeNames.DELIVERY_APP_OPEN} element={<Pages.DeliveryAppOpen />} />

				{!token && <>
					<Route exact path={routeNames.HOME_ROUTE} element={<Auth.SignIn />} />
				</>}

				{pharmacyId && <Route exact path={routeNames.verify_otp} element={<ProtectedRoute Component={Auth.DriverOtpVerification}></ProtectedRoute>} />}

				<Route exact path={routeNames.SWITCH_PHARMACY} element={<ProtectedRoute Component={Pages.SwitchPharmacy}></ProtectedRoute>} />

				{pharmacyId && verifiedOtp === 1 ? <>
					<Route exact path={`${routeNames.DASHBOARD_PHARMACY}`} element={<ProtectedRoute Component={Pages.DriverDashboard}></ProtectedRoute>} />
					<Route exact path={`${routeNames.DRIVER_ROUTE_TODAY}`} element={<ProtectedRoute Component={Pages.TodayDispense}></ProtectedRoute>} />
					<Route exact path={`${routeNames.TODAY_APPOINTMENT_DELIVERIES}`} element={<ProtectedRoute Component={Pages.TodayAppointmentDeliveries}></ProtectedRoute>} />
					<Route exact path={`${routeNames.PICKED_PATIENTS}`} element={<ProtectedRoute Component={Pages.PickedPatients}></ProtectedRoute>} />

					<Route exact path={`${routeNames.PHARMACY_FRONT_PROFILE}`} element={<ProtectedRoute Component={Pages.PharmacyFrontProfile}></ProtectedRoute>} />
					<Route exact path={`${routeNames.DRIVER_DIGITAL_CARD}`} element={<ProtectedRoute Component={Pages.DriverDigitalCard}></ProtectedRoute>} />
					{isDriverForAuthorizationLetter ? (
						<Route exact path={`${routeNames.DRIVER_AUTHORIZATION_LETTER}`} element={<ProtectedRoute Component={Pages.DriverAuthorizationLetter}></ProtectedRoute>} />
					) : null}

					<Route exact path={routeNames.DRIVER_PASSWORD} element={<ProtectedRoute Component={Pages.ChangePassword}></ProtectedRoute>} />
					<Route exact path={`${routeNames.MY_PROFILE}`} element={<ProtectedRoute Component={Pages.MyProfile}></ProtectedRoute>} />
					<Route exact path={routeNames.DRIVER_PASSCODE} element={<ProtectedRoute Component={Pages.UpdatePasscode}></ProtectedRoute>} />

					<Route exact path={`${routeNames.Patient_Consent}`} element={<ProtectedRoute Component={Pages.PatientConsent}></ProtectedRoute>} />
					<Route exact path={`${routeNames.Missed_Route}`} element={<ProtectedRoute Component={Pages.MissedDeliveryPatient}></ProtectedRoute>} />
					<Route exact path={`${routeNames.driver_Missed_Route}`} element={<ProtectedRoute Component={Pages.FinalMissedDelivery}></ProtectedRoute>} />

					<Route exact path={`${routeNames.DRIVER_ROUTE_DELIVERED}`} element={<ProtectedRoute Component={Pages.DeliveredPatientDispense}></ProtectedRoute>} />
					<Route exact path={`${routeNames.driver_today_pending}`} element={<ProtectedRoute Component={Pages.PendingDispense}></ProtectedRoute>} />
					<Route exact path={`${routeNames.ADD_VITALS}`} element={<ProtectedRoute Component={Pages.AddVitals}></ProtectedRoute>} />
					<Route exact path={`${routeNames.search_patient_data}`} element={<ProtectedRoute Component={Pages.SearchPatientList}></ProtectedRoute>} />

					<Route exact path={`${routeNames.flexi_delivery}`} element={<ProtectedRoute Component={Pages.FlexiDelivery}></ProtectedRoute>} />
					<Route exact path={`${routeNames.updates}`} element={<ProtectedRoute Component={Pages.Updates}></ProtectedRoute>} />
					{/* <Route exact path={`${routeNames.updates_3x_4x}`} element={<ProtectedRoute Component={Pages.Updates3x4x}></ProtectedRoute>} />
                                        <Route exact path={`${routeNames.updates_prep_emergencies}`} element={<ProtectedRoute Component={Pages.PrepEmergencies}></ProtectedRoute>} /> */}

					<Route exact path={`${routeNames.upload_prescripition}`} element={<ProtectedRoute Component={Pages.UploadPrescripition}></ProtectedRoute>} />
					<Route exact path={`${routeNames.pending_counselling}`} element={<ProtectedRoute Component={Pages.PendingCounselling}></ProtectedRoute>} />


					{pharmacy_assign_chats &&
						<Route exact path={`${routeNames.pharmacy_initated_chat}`} element={<ProtectedRoute Component={ChatInterface}></ProtectedRoute>} />}

					{((isSupervisor === 1 && supervisor_pharmacist) || supervisorOfTheDay) && <>
						<Route exact path={`${routeNames.today_analytics}`} element={<ProtectedRoute Component={Pages.TodaysAnalytics}></ProtectedRoute>} />
					</>}

					{((isSupervisor === 1 && supervisor_pharmacist) || analyticSupervisorOftheDay) && <>
						<Route exact path={`${routeNames.Counselling}`} element={<ProtectedRoute Component={Pages.Counselling}></ProtectedRoute>} />
						<Route exact path={`${routeNames.change_default_pharmacist}`} element={<ProtectedRoute Component={Pages.ChangeDefaultPharmacist}></ProtectedRoute>} />
						<Route exact path={`${routeNames.mark_attandance}`} element={<ProtectedRoute Component={Pages.SupverVisorAttandance}></ProtectedRoute>} />
						<Route exact path={`${routeNames.pharmacy_add_assitant}`} element={<ProtectedRoute Component={Pages.PharmacyAssistants}></ProtectedRoute>} />
						{!analyticSupervisorOftheDay && <>
							<Route exact path={`${routeNames.pending_pharmacist_signatures}`} element={<ProtectedRoute Component={Pages.PendingPharmacistSignatures}></ProtectedRoute>} />
							<Route exact path={`${routeNames.pharmacist_of_th_day}`} element={<ProtectedRoute Component={Pages.PharmacistOfTheDay}></ProtectedRoute>} />
						</>}
					</>}

				</> :
					!pharmacyId && token ?
						<Route exact path={routeNames.SWITCH_PHARMACY} element={<ProtectedRoute Component={Pages.SwitchPharmacy}></ProtectedRoute>} />

						: verifiedOtp === 0 && pharmacyId && token ?
							<Route exact path={routeNames.verify_otp} element={<Auth.DriverOtpVerification />} /> :

							pharmacyId && token ?
								<Route exact path={routeNames.verify_otp} element={<Auth.DriverOtpVerification />} />
								:
								<Route path="*" element={<Auth.SignIn />} />
				}

				{
					token && !pharmacyId ?
						<Route path="*" element={<Pages.SwitchPharmacy />} />
						:

						token && pharmacyId && verifiedOtp === 1 ?
							<Route path="*" element={<Pages.DriverDashboard />} />
							:
							token && pharmacyId && verifiedOtp === 0 ?
								<Route path="*" element={<Auth.DriverOtpVerification />} />
								:
								token && pharmacyId ?
									<Route path="*" element={<Auth.DriverOtpVerification />} />
									:
									<Route path="*" element={<Auth.SignIn />} />
				}

			</Routes>
			<ToastContainer />

			{pharmacy_assign_chats ?
				location.pathname.startsWith(routeNames.pharmacy_initated_chat) || location.pathname === routeNames.mark_attandance ? <ActivityTracker /> :
					pharmacyId && token && verifiedOtp === 1 && <>
						<ChatBox />
						<ActivityTracker />
					</> : null
			}
		</>
	)
}

export default AppRoutes


